import { render } from "./addpurchase.vue?vue&type=template&id=6d506a69"
import script from "./addpurchase.vue?vue&type=script&lang=js"
export * from "./addpurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__